// extracted by mini-css-extract-plugin
export const socialContainer = "socialfollow-module--socialContainer--FWNQm";
export const social = "socialfollow-module--social--qsmWf";
export const linkedIn = "socialfollow-module--linkedIn--13yIY";
export const facebook = "socialfollow-module--facebook--36irn";
export const stackoverflow = "socialfollow-module--stackoverflow--1PZE8";
export const medium = "socialfollow-module--medium--2le4O";
export const github = "socialfollow-module--github--1NDBZ";
export const twitter = "socialfollow-module--twitter--o3_Q0";
export const instagram = "socialfollow-module--instagram--1iMAB";
export const mail = "socialfollow-module--mail--3W7Oa";
export const quora = "socialfollow-module--quora--3kl9x";
export const dev = "socialfollow-module--dev--2gon2";